import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useQuery } from '@apollo/client';
import classNames from 'classnames/bind';

import Modal from '@mui/material/Modal';
import DialogContent from '@mui/material/DialogContent';

import * as Q from '../../../constants/graphqlQueries';
import { authenticationDenied } from '../../../constants/accessDeniedMessages';
import ModalDetail from '../../ModalDetail/ModalDetail';

import styles from './AspectStatus.module.css';

const cx = classNames.bind(styles);

const AspectStatus = ({ StatusResponse }) => {
  const [open, setOpen] = useState(false);

  const { loading, error, data } = useQuery(Q.ASPECT_STATUS_QUERY, {
    pollInterval: 15 * 60 * 1000,
  });

  // Handle loading state
  if (loading) return <p>Loading...</p>;

  // Handle error state
  if (error) {
    if (!open) setOpen(true);
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={true}
      >
        <DialogContent className='dialog delete-rule'>
          <ModalDetail 
            className='modal delete-rule'
            modalOptions={authenticationDenied}
          />
        </DialogContent>
      </Modal>
    );
  }

  // Handle null data
  if (!data || !data.aspectHealthWebService) {
    return <p>No data available</p>;
  }

  const status = data.aspectHealthWebService;

  const classNameStatus = cx({
    status: true,
    error: status !== StatusResponse,
    ok: status === StatusResponse,
  });

  const classNameLabel = cx({
    aspectHealthOptions: true,
  });

  return (
    <div className={classNameLabel}>
      Web Service:
      <div className={classNameStatus}>{status}</div>
    </div>
  );
};

AspectStatus.propTypes = {
  StatusResponse: PropTypes.string.isRequired,
};

export default AspectStatus;
